import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function DispatcherAuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6" data-testid="dispatcher-audit">
      <div>
        <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Audit Log</h1>
        <p className="text-slate-500 mt-1">Full activity history (super admin only).</p>
      </div>
      <Card>
        <CardContent className="p-0">
          <div className="divide-y divide-slate-200">
            {logs.map((l) => (
              <div key={l.id} className="p-4 flex items-center justify-between hover:bg-slate-50">
                <div>
                  <div className="font-semibold text-sm capitalize text-slate-900">{l.action} · {l.entity_type}</div>
                  <div className="text-xs text-slate-500">{l.entity_id} · {l.user_id?.slice(0, 8)}</div>
                </div>
                <div className="text-xs text-slate-500">{l.created_at?.slice(0, 19).replace("T", " ")}</div>
              </div>
            ))}
            {logs.length === 0 && <div className="text-center py-12 text-slate-500">Audit log requires super-admin access.</div>}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
